var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongDianzanMianxing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.782 2.4a1.05 1.05 0 01.87-.464h.769c.605 0 1.086.51 1.048 1.115l-.166 2.659h2.55c.67 0 1.17.62 1.025 1.275l-1.238 5.64a.95.95 0 01-.928.747H2.903a.95.95 0 01-.95-.95V7.575a.95.95 0 01.95-.95h2.033L7.782 2.4zM4.563 7.666v4.666h.9V7.667h-.9z",
    fill: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_dianzan_mianxing.1cfc04f6.svg";
export { SvgTongyongDianzanMianxing as ReactComponent };